import classNames from "classnames";
import { html, TemplateResult } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import i18next from "i18next";

export const adminErrorTemplate = (message: string): TemplateResult => html`
	<div class="w-full text-center">
		<span
			class="mx-auto mb-5 mt-2 inline-block rounded-md bg-[#e299a1] px-6 py-3 text-left text-sm/4 text-[#163a6f]"
		>
			${unsafeHTML(message)}
		</span>
	</div>
`;

export const adminCaptchaTemplate = (captchaContainerId: string): TemplateResult => html`
	<div class="w-full text-center">
		<div id=${captchaContainerId}>
			<div></div>
		</div>
	</div>
`;

export const adminTooltipIconTemplate = (): TemplateResult => html`
	<div
		class="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border border-solid border-brand-secondary text-xl text-brand-secondary"
	>
		!
	</div>
`;

export const adminTooltipTemplate = (text: string): TemplateResult => html`
	<div
		class=${classNames(
			"absolute -top-2 -translate-y-full left-1/2 transform -translate-x-1/2 opacity-0 group-focus-within:opacity-100",
			"w-full max-w-[340px] h-auto p-4",
			"bg-white shadow-md border border-solid border-n-dark-gray rounded-md",
			"pointer-events-none"
		)}
	>
		<div class="flex w-full items-center justify-between gap-2">
			${adminTooltipIconTemplate()}
			<div class="text-sm text-brand-secondary">${text}</div>
		</div>
		<div
			class="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 transform border-l-21 border-r-21 border-t-21 border-solid border-l-transparent border-r-transparent border-t-black"
		></div>
		<div
			class="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 transform border-l-20 border-r-20 border-t-20 border-solid border-l-transparent border-r-transparent border-t-white"
		></div>
	</div>
`;

export const adminRecaptchaErrorTemplate = (captchaStatus: string): string | TemplateResult =>
	captchaStatus === "error" ? adminErrorTemplate(i18next.t("CaptchaLoadError")) : "";
